import React,{useMemo} from 'react';
import useLookUpBase from '../../components/selectbox/LookupBase';

type LookupOptions = {
    id: string;
    description: string;
  };

const createLookup = (dataSource: any,  idRow: string,) => {
    const lookup: { [key: string]: string } = {};
    if (dataSource) {
      dataSource.forEach((item: LookupOptions) => {
        lookup[item.id] = item.description;
      });
    }
    return lookup;
  };

  export default createLookup